import React, { useEffect } from "react";
import { DataTable } from "./DataTable";
import { Button, DatePicker, Radio, Tabs, Input, Select } from "antd";
import { YhBox } from "@/components/YhBox";
import { useOrderModel } from "../orderModel";
import "./statistics.less"
import { vehicleDetialModel } from './details/vehicleDetialModel'
import moment from "moment";
import { RangePickerProps } from 'antd/lib/date-picker'
import dayjs from "dayjs";
import useGlobalModel from '@/model/globalModel';

export const DataBox = () => {
    const { initPgCfg, loadData, searchParam, setSearchParam, totalNum, fleetList, companyList, fleetName, setFleetName, companyName, setCompanyName, exportListData, resetSearchParam } = useOrderModel();
    const { authData } = useGlobalModel(({ user }) => [user]);
    const { RangePicker } = DatePicker
    const { setPrint, setPrintStatus } = vehicleDetialModel()

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fleetName, companyName])
    // eslint-disable-next-line arrow-body-style
    const disabledDate: RangePickerProps['disabledDate'] = (current) => {
        // Can not select days before today and today
        return current && current > dayjs().endOf('day');
    };
    //不同条件检索
    const search = (value) => {
        let obj: any = {}
        if (value === 'week') {
            let time = new Date().getTime()
            let endTime = time - 7 * 24 * 3600 * 1000
            obj.startTime = dayjs(endTime).format('YYYY-MM-DDT00:00:00')
            obj.endTime = dayjs(time).format('YYYY-MM-DDT23:59:59')
        } else if (value === 'month') {
            let Nowdate = new Date()
            let nowMonth = Nowdate.getMonth() // 当前月
            let nowYear = Nowdate.getFullYear() // 当前年
            let time = new Date().getTime()// 当前时间
            let monthStartDate = new Date(nowYear, nowMonth, 1)// 本月的开始时间
            obj.startTime = dayjs(monthStartDate).format('YYYY-MM-DDT00:00:00')
            obj.endTime = dayjs(time).format('YYYY-MM-DDT23:59:59')
        } else if (value === 'year') {
            let Nowdate = new Date()
            let nowYear = Nowdate.getFullYear() // 当前年
            let yearStartDate = new Date(nowYear, 0, 1)// 本年的开始时间			
            let time = new Date().getTime()// 当前时间
            obj.startTime = dayjs(yearStartDate).format('YYYY-MM-DDT00:00:00')
            obj.endTime = dayjs(time).format('YYYY-MM-DDT23:59:59')
        }
        setSearchParam(obj)
        loadData(initPgCfg, obj)
    }
    const action = <>
        <Button className="m-15" shape="round" type='primary' onClick={() => exportListData()}>导出</Button>
        <Button className="m-15" shape="round" type='primary' onClick={() => { setPrint(true); setPrintStatus('outDetial') }}>
            打印
        </Button>
        <span style={{ float: 'right', fontSize: '15px', fontWeight: 'bolder', marginBottom: '7px' }}>总单据数量:<span style={{ color: '#4062d8', fontSize: '22px', marginLeft: '5px' }}>{totalNum}</span></span>
    </>;

    return (
        <div style={{ backgroundColor: '#fff' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', padding: '20px', }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    工单日期：
                    <RangePicker
                        size="small"
                        style={{ width: '300px' }}
                        format="YYYY-MM-DD"
                        onChange={(value, timeStr) => {
                            let obj = timeStr[0] !== '' && timeStr[1] !== '' ? {
                                startTime: timeStr[0] + 'T00:00:00',
                                endTime: timeStr[1] + 'T23:59:59'
                            } : {}
                            setSearchParam({ ...searchParam, ...obj })
                            loadData(initPgCfg, { ...searchParam, ...obj })
                        }}
                        disabledDate={disabledDate}
                        value={
                            (
                                searchParam
                                && searchParam.startTime
                                && searchParam.endTime
                            )
                                ? [moment(searchParam.startTime), moment(searchParam.endTime)]
                                : undefined
                        }
                    />
                    <span style={{ color: '#2596ff', cursor: 'pointer', margin: '0 10px 0 30px' }} onClick={() => search('week')}>最近7天</span>
                    <span style={{ color: '#2596ff', cursor: 'pointer', margin: '0 10px' }} onClick={() => search('month')}>查询当月</span>
                    <span style={{ color: '#2596ff', cursor: 'pointer', margin: '0 10px' }} onClick={() => search('year')}>查询当年</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                    车辆牌照：
                    <Input
                        size="small"
                        style={{ width: '300px' }}
                        allowClear
                        datatype="round"
                        placeholder="请输入车辆牌照"
                        onPressEnter={() => {
                            loadData(initPgCfg, searchParam)
                        }}
                        value={searchParam.customerVehicleCode}
                        onChange={(e) => {
                            setSearchParam({ ...searchParam, customerVehicleCode: e.target.value })
                        }} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                    车队：
                    <Select
                        size="small"
                        style={{ width: '300px' }}
                        mode="multiple"
                        allowClear
                        placeholder="请选择车队"
                        value={searchParam.vehicleSite ? searchParam.vehicleSite.split(',') : []}
                        onChange={(values) => {
                            const vehicleSite = values.join(',');
                            setSearchParam({ ...searchParam, ...{ vehicleSite } })
                        }}
                        onBlur={() => {
                            loadData(initPgCfg, searchParam)
                        }}>
                        {[{ label: '全部', value: '', type: '管理员' }, ...authData].filter((item) => item.type === '管理员')?.map((item) => (
                            <Select.Option key={item.value} value={item.value}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                <div style={{ display: 'flex', padding: '20px', alignItems: 'center' }}>
                    <Button size="small" onClick={() => {
                        loadData(initPgCfg, searchParam)
                    }} type="primary" className="header-search">
                        检索
                    </Button>
                    <Button size="small" onClick={() => {
                        resetSearchParam()
                    }} className="header-reset">
                        重置
                    </Button>
                </div>
            </div>
            <hr style={{ border: 'none', height: '1px', backgroundColor: '#ccc', margin: '3px 10px' }} />
            <Radio.Group onChange={(e) => setCompanyName(e.target.value)} value={companyName} style={{ margin: '10px' }}>
                {companyList?.map((item, index) => <Radio.Button type="primary" value={item} key={index}>{item}</Radio.Button>)}
            </Radio.Group>
            <Tabs
                onChange={(e) => setFleetName(e)}
                style={{ margin: '0 20px' }}
                items={fleetList.map(item => {
                    return {
                        label: item,
                        key: item,
                        children: <YhBox title="" action={action} style={{ maxHeight: '800px', padding: '0', overflowY: 'auto' }}>
                            <DataTable />
                        </YhBox>,
                    };
                })}
            />,
        </div >
    )
}